

































































import { Vue } from "vue-property-decorator";
import type { stadium_ground, stadium_ground_price } from "@/@types/stadium/ground"
import moment from "moment"

export default Vue.extend({
  name : "InvestLogInfo",
  props: {
    width     : { type: String, default: "800px" },
    id        : { type: String, required: true },
    stadium_id: { type: String, required: true },
  },
  computed: {
    sum() {
      return this.$data.data.price + this.$data.data.premium_price
    },
  },
  data() {
    return {
      type   : 1,
      title  : "",
      range  : [] as Array<any>,
      visible: false,
      loading: false,
      list   : [] as stadium_ground[],
      data   : {
        ground_ids   : [] as string[],
        stadium_id   : 0,
        type         : 0,
        price        : 0.00,
        price_type   : 0,
        premium_price: 0.00,
        weeks        : [] as string[],
        hour_from    : "",
        min_from     : "00",
        hour_to      : "",
        min_to       : "00",
      } as stadium_ground_price,
      rules : {
        ground_ids: { required: true, message: "请选择片场", trigger: "blur" },
      },
      week_days: { 1: "周一", 2: "周二", 3: "周三", 4: "周四", 5: "周五", 6: "周六", 0: "周日" },
      days     : [
        { label: "周一", value: "1" },
        { label: "周二", value: "2" },
        { label: "周三", value: "3" },
        { label: "周四", value: "4" },
        { label: "周五", value: "5" },
        { label: "周六", value: "6" },
        { label: "周日", value: "7" },
      ],
      time: {
        hour_from: null as moment.Moment | null,
        hour_to  : null as moment.Moment | null,
      }
    }
  },
  methods: {
    open(title: string, type: number, range: []) {
      this.$nextTick(() => {
        this.type  = type
        this.title = title
        this.range = range
        this.get_grounds()
        this.visible = true
        this.loading = false
      })
    },
    async get_grounds() {
      const params = { stadium_id: this.stadium_id }
      const res = await this.$store.dispatch("stadium/getStadiumGrounds", params);
      if (res.Code == 200) {
        this.list = res.Data
      }
    },
    check_range(): boolean {
      let flag = false
      if (this.data.hour_from == "" || this.data.hour_to == "") {
        this.$warning({ content: "请选择时间周期" })
        return false
      }
      const s = moment([this.data.hour_from, this.data.min_from].join(":"), "HH:mm")
      const e = moment([this.data.hour_to, this.data.min_to].join(":"), "HH:mm")
      for (let day of this.data.weeks) {
        if (day == "7") day = "0"
        flag = true
        /* 判断时间是否超出 */
        for (const range of this.range) {
          if (range.indexOf(day) != -1) {
            const start = moment(range[0].split("-")[0], "HH:mm")
            const end   = moment(range[0].split("-")[1], "HH:mm")
            if (s.isSameOrAfter(start) && e.isSameOrBefore(end)) {
              flag = false
              break
            }
          }
        }
        if (flag) break
      }
      if (flag) this.$error({ content: "所选时段超过营业时间" })
      return !flag
    },
    async submit() {
      this.data.stadium_id = Number(this.stadium_id)
      this.data.type = this.type
      if (this.time.hour_from) this.data.hour_from = this.time.hour_from.format("HH")
      if (this.time.hour_to) this.data.hour_to = this.time.hour_to.format("HH")
      const params = this.$deep_copy(this.data)
      params.estimate_id = this.id
      const form = this.$refs.ground_price_form as any
      form.validate(async (valid: boolean) => {
        if (valid) {
          const check = this.check_range()
          if (check) {
            this.loading = true
            this.$emit("change", params)
            this.close()
            /* const res = await this.$store.dispatch("invest_correct/add_price", params);
            if (res.Code == 200) {
              this.$success({
              content: "添加成功",
                onOk: () => {}
              })
            } else this.$error({ content: res.Message }) */
          }
        }
      })
    },
    close() {
      const form = this.$refs.ground_price_form as any
      form.resetFields()
      this.loading = false
      this.visible = false
    }
  }
})

